import "./style.css";

// =================== UserList Start here ====================
export const userList = [
  {
    address: "Cairo",
    city: "Dahab",
    clientName: "Reem Magdy",
    country: "Egypt",
    email: "rmagdy.2233@gmail.com",
    password: "reem1234",
    phone: "0123456789",
    zip: "11511",
    isAdmin: true,
  },
];

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Trips",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "Hotels",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
  {
    _id: 1005,
    title: "News",
    link: "News",
  },
];
// =================== NavBarList End here ======================
